import { UpgradeCurrentPackage } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { portalRedirectModel } from '~/features/portal/redirect'
import {
  $playerSubscriptionLimitationsQualityTranslations,
  $playerSubscriptionLimitationsTranslations,
} from '../translations'
import * as model from './model'

interface UpgradeCurrentPackageWidgetParams {
  smallPlayer?: boolean
}

export const UpgradeCurrentPackageWidget = ({
  smallPlayer,
}: UpgradeCurrentPackageWidgetParams) => {
  const playerSubscriptionLimitationsTranslations = useUnit(
    $playerSubscriptionLimitationsTranslations
  )
  const qualityTranslations = useUnit(
    $playerSubscriptionLimitationsQualityTranslations
  )

  const showWidget = useUnit(model.$showUpgradePackageWidget)
  const selectedQuality = useUnit(model.$selectedQuality)
  const isLoading = useUnit(
    portalRedirectModel.getPortalAccountAccessTokenFx.pending
  )
  const hideUpgradePackageWidget = useUnit(model.hideUpgradePackageWidget)
  const navigateToAccountSettings = useUnit(
    portalRedirectModel.navigateToAccountSettings
  )

  // Hide the widget if the widget was open and then player left full-screen mode
  useEffect(() => {
    if (smallPlayer != null && smallPlayer) {
      hideUpgradePackageWidget()
    }
  }, [smallPlayer, hideUpgradePackageWidget])

  if (!showWidget || !selectedQuality) {
    return null
  }

  const onUpgrade = () => {
    hideUpgradePackageWidget()
    navigateToAccountSettings()
  }

  const onCancel = () => {
    hideUpgradePackageWidget()
  }

  const qualityTranslationsWithQuality = qualityTranslations(
    String(selectedQuality)
  )

  return (
    <UpgradeCurrentPackage
      title={
        playerSubscriptionLimitationsTranslations.subscription_upgrade_required_title
      }
      description={
        qualityTranslationsWithQuality.subscription_upgrade_required_text
      }
      updateButtonText={
        playerSubscriptionLimitationsTranslations.upgrade_button
      }
      cancelButtonText={playerSubscriptionLimitationsTranslations.cancel_button}
      onUpgrade={onUpgrade}
      onCancel={onCancel}
      isLoading={isLoading}
    />
  )
}
